import {IconButton, useSidebarOpen} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {useTheme} from './ThemeProvider';

import type {FC} from 'react';

export const ThemeSwitcher: FC = () => {
  const {theme, setTheme} = useTheme();
  const {t} = useTranslation('common');
  const isOpen = useSidebarOpen();
  const collapsed = isOpen === false;
  const isDark = theme === 'dark';

  return (
    <IconButton
      icon={isDark ? 'moon' : 'sun'}
      aria-label={t('theme.toggle')}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={collapsed ? 'size-10 bg-background-secondary' : 'size-8'}
    />
  );
};
